import React, { useState } from 'react';
import styles from './CopyButton.module.css';
import BaseText from '../BaseText/BaseText';

interface CopyButtonProps {
  textToCopy: string;
  itemId: string;
  setCopiedItemId: (itemId: string) => void;
  copiedItemId: string;
  showTooltip?: boolean;
  showCopyText?: boolean;
  iconWidth?: number;
  onCopyToClipboard?: () => void;
}

function CopyButton({
  textToCopy, itemId, setCopiedItemId, copiedItemId, showTooltip = true, showCopyText, iconWidth = 15, onCopyToClipboard,
}: CopyButtonProps) {
  const [isClicked, setIsClicked] = useState(false);

  const copyToClipboard = (text: string, id: string) => {
    navigator.clipboard.writeText(text);
    setCopiedItemId(id);
    setIsClicked(true);
    setTimeout(() => {
      setIsClicked(false);
      setCopiedItemId('');
    }, 1500);
    if (onCopyToClipboard) onCopyToClipboard();
  };

  return (
    <div
      className={showCopyText ? styles.copyContainerWithText : styles.copyContainer}
      style={{ cursor: showCopyText ? 'pointer' : 'default' }}
    >
      <div
        className={showCopyText ? styles.copyButtonContainer : undefined}
        onClick={showCopyText ? () => copyToClipboard(textToCopy, itemId) : undefined}
        role="button"
        tabIndex={0}
      >
        <img
          className={`${styles.button} ${isClicked ? 'clicked' : ''}`}
          width={iconWidth}
          src={(isClicked && showCopyText) ? '/images/check-solid-gray.svg' : '/images/copy.svg'}
          onClick={() => copyToClipboard(textToCopy, itemId)}
          alt="Copy"
          style={{ cursor: 'pointer' }}
        />
        { showCopyText && (
        <BaseText size="xs">
          {(isClicked && showCopyText) ? 'コピー済み' : 'コピー'}
        </BaseText>
        ) }
      </div>
      {((copiedItemId === itemId) && showTooltip) && <div className={styles.copiedMessage}>コピーしました！</div>}
    </div>
  );
}

export default CopyButton;
